/**
 * Button constants
 *
 * @author: exode <hello@exode.ru>
 */

export const mStickyBottom2PbSafe = 'm:mt-auto m:sticky m:bottom-5 m:pb-safe m:z-10';
